import React, { useState } from 'react';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Link from '@mui/material/Link';
import ForgotPassword from '../Modals/ForgotPassword';

const Signin = ({ setCurrentUser, setShowAuth, setError, socket }) => {

    const [data, setData] = useState({
        username: "",
        password: "",
    });

    const [forgotPassword, setForgotPassword] = useState(false);

    const handleSubmit = e => {
        e.preventDefault();
        socket.emit("user login", data);
        socket.on('login user', data => {
            localStorage.setItem('auth_token', data.jwt);
            localStorage.setItem('_id', data._id);
            setCurrentUser({ user: data, isAuthenticated: true, adminSettings: true });
            setShowAuth(false);
        });
        socket.on('error', data => {
            setError({ ...data, show: true });
        });
    }

    return (
        <Box component="form" onSubmit={handleSubmit}>
            <Stack spacing={2}>
                <TextField
                    label="Callsign"
                    name="username"
                    value={data.username}
                    onChange={e => setData({ ...data, username: e.target.value.toUpperCase() })}
                    required
                    fullWidth
                />
                <TextField
                    label="Password"
                    name="password"
                    type="password"
                    value={data.password}
                    onChange={e => setData({ ...data, password: e.target.value })}
                    required
                    fullWidth
                />
                <Link component="button" type="button" underline="hover" onClick={() => setForgotPassword(true)} sx={{ alignSelf: 'flex-start' }}>
                    Forgot Password
                </Link>
                <Button type="submit" variant="contained" fullWidth>Sign In</Button>
            </Stack>
            <ForgotPassword
                existingUsername={data.username}
                forgotPassword={forgotPassword}
                setForgotPassword={setForgotPassword}
                socket={socket}
            />
        </Box>
    )
}

export default Signin
